<template>
  <div v-for="menuH2 in menus" :key="menuH2.name" class="margin-y-20">
    <h2>{{ menuH2.name }}</h2>
    <h3
      v-for="menuH3 in menuH2.children"
      :key="menuH3.name"
      :class="{ active: $route.path === menuH3.path }"
      @click="$router.push(menuH3.path)"
    >
      {{ menuH3.name }}
    </h3>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {
          name: 'Guide 指南',
          children: [
            { path: '/guide/design-concept', name: '设计理念' },
            { path: '/guide/installation', name: '安装' },
            { path: '/guide/quickstart', name: '快速开始' },
            { path: '/guide/additional-style', name: '附赠样式' },
          ],
        },
        // {
        //   name: 'Echarts 图表',
        //   children: [
        //     { path: '/echarts/linechart', name: '折线图' },
        //     { path: '/echarts/areachart', name: '面积图' },
        //     { path: '/echarts/barchart', name: '柱状图' },
        //   ],
        // },
        // {
        //   name: 'Canvas 画布',
        //   children: [
        //     { path: '/canvas/particle', name: '粒子效果' },
        //     // { path: '/canvas/areachart', name: '面积图' },
        //     // { path: '/canvas/barchart', name: '柱状图' },
        //   ],
        // },
        {
          name: 'Basic 基础组件',
          children: [
            { path: '/components/basic/button', name: 'Button 按钮' },
            { path: '/components/basic/border', name: 'Border 边框' },
            { path: '/components/basic/color', name: 'Color 颜色' },
          ],
        },
        {
          name: 'Form 表单组件',
          children: [
            { path: '/components/form/cascader', name: 'Cascader 级联选择器' },
            { path: '/components/form/checkbox', name: 'Checkbox 多选框' },
            { path: '/components/form/date-picker', name: 'DatePicker 日期选择器' },
            { path: '/components/form/date-time-picker', name: 'DateTimePicker 日期时间选择器' },
            { path: '/components/form/form', name: 'Form 表单' },
            { path: '/components/form/input', name: 'Input 输入框' },
            { path: '/components/form/input-number', name: 'Input Number 数字输入框' },
            { path: '/components/form/radio', name: 'Radio 单选框' },
            { path: '/components/form/rate', name: 'Rate 评分' },
            { path: '/components/form/select', name: 'Select 选择器' },
            { path: '/components/form/select-v2', name: 'Select V2 虚拟列表选择器' },
            { path: '/components/form/slider', name: 'Slider 滑块' },
            { path: '/components/form/switch', name: 'Switch 开关' },
            { path: '/components/form/time-picker', name: 'TimePicker 时间选择器' },
            { path: '/components/form/time-select', name: 'TimeSelect 时间选择' },
            { path: '/components/form/transfer', name: 'Transfer 穿梭框' },
            { path: '/components/form/upload', name: 'Upload 上传' },
          ],
        },
        {
          name: 'Data 数据展示',
          children: [
            { path: '/components/data/badge', name: 'Badge 徽章' },
            { path: '/components/data/calendar', name: 'Calendar 日历' },
            { path: '/components/data/card', name: 'Card 卡片' },
            { path: '/components/data/carousel', name: 'Carousel 走马灯' },
            { path: '/components/data/collapse', name: 'Collapse 折叠面板' },
            { path: '/components/data/descriptions', name: 'Descriptions 描述列表' },
            { path: '/components/data/pagination', name: 'Pagination 分页' },
            { path: '/components/data/progress', name: 'Progress 进度条' },
            { path: '/components/data/table', name: 'Table 表格' },
            { path: '/components/data/tag', name: 'Tag 标签' },
            { path: '/components/data/timeline', name: 'Timeline 时间线' },
            { path: '/components/data/tree', name: 'Tree 树形控件' },
            { path: '/components/data/tree-v2', name: 'Tree V2 虚拟化树形控件' },
          ],
        },
        {
          name: 'Navigation 导航',
          children: [
            { path: '/components/navigation/backtop', name: 'Backtop 回到顶部' },
            { path: '/components/navigation/breadcrumb', name: 'Breadcrumb 面包屑' },
            { path: '/components/navigation/dropdown', name: 'Dropdown 下拉菜单' },
            { path: '/components/navigation/menu', name: 'Menu 菜单' },
            { path: '/components/navigation/steps', name: 'Steps 步骤条' },
            { path: '/components/navigation/tabs', name: 'Tabs 标签页' },
          ],
        },
        {
          name: 'Feedback 反馈组件',
          children: [
            { path: '/components/feedback/dialog', name: 'Dialog 对话框' },
            { path: '/components/feedback/drawer', name: 'Drawer 抽屉' },
            { path: '/components/feedback/loading', name: 'Loading 加载' },
            { path: '/components/feedback/message', name: 'Message 消息提示' },
            { path: '/components/feedback/message-box', name: 'MessageBox 弹框' },
            { path: '/components/feedback/notification', name: 'Notification 通知' },
            { path: '/components/feedback/popconfirm', name: 'Popconfirm 气泡确认框' },
            { path: '/components/feedback/popover', name: 'Popover 气泡卡片' },
            { path: '/components/feedback/tooltip', name: 'Tooltip 文字提示' },
          ],
        },
        {
          name: 'Others 其他',
          children: [{ path: '/components/others/divider', name: 'Divider 分割线' }],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.el-aside {
  --el-aside-width: 285px !important;
  padding: 0 20px;
  border-right: 1px solid var(--dark-bg-color-light-3, #eee);

  h2 {
    margin: 0;
    padding: 15px 10px;
    font-size: 16px;
    font-weight: bold;
    color: var(--el-text-color-secondary);
  }

  h3 {
    margin: 0 20px 0 0;
    padding: 10px 10px 10px 20px;
    font-size: 14px;
    font-weight: normal;
    color: var(--el-text-color-regular);
    cursor: pointer;

    &:hover {
      background-color: var(--dark-bg-color-light-1);
      color: var(--el-text-color-primary);
    }

    &.active,
    &:active {
      background-color: var(--dark-bg-color-light-3);
      color: var(--el-text-color-primary);
    }
  }
}
</style>
